<app-favorite-header [description]="item.description" [iconClass]="'icon-card2'">
    <app-delete-favorite [favId]="item.favId" deletable></app-delete-favorite>
    <app-card-pending-check 
        [favorite]="item.favorite" 
        [card]="card" 
        pendingCharge
    ></app-card-pending-check>
    <app-favorite-card-alias [alias]="item.favorite"></app-favorite-card-alias>
</app-favorite-header>
<app-loading-animation [width]="80" [isRouting]="!card" [margin]="'10% 0% 0% 40%'">
  <app-usage-information 
      [favorite]="item.favorite" 
      [card]="card"
  ></app-usage-information>
  <app-card-buttons 
      [card]="card" 
      [type]="item.favorite"
  ></app-card-buttons>
</app-loading-animation>